var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        "close-on-click-modal": !1,
        title: "修改密码",
        "append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "form",
          attrs: {
            model: _vm.formData,
            "label-width": "80px",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "原密码", prop: "currentPassword" } },
            [
              _c("el-input", {
                attrs: { type: "password", placeholder: "请输入原密码" },
                model: {
                  value: _vm.formData.currentPassword,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "currentPassword", $$v)
                  },
                  expression: "formData.currentPassword",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "新密码", prop: "newPassword" } },
            [
              _c("el-input", {
                attrs: { type: "password", placeholder: "请输入新密码" },
                model: {
                  value: _vm.formData.newPassword,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "newPassword", $$v)
                  },
                  expression: "formData.newPassword",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "确认密码", prop: "confirmPassword" } },
            [
              _c("el-input", {
                attrs: { type: "password", placeholder: "请确认新密码" },
                model: {
                  value: _vm.formData.confirmPassword,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "confirmPassword", $$v)
                  },
                  expression: "formData.confirmPassword",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm()
                    },
                  },
                },
                [_vm._v("提交")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }